import bulkItems from './bulkItems';
import prepareBulkDelete from './prepareBulkDelete';

export default (ids, value, filterData = {}, callback = null) =>
    (dispatch) => {
        switch (value) {
            case 'deleted':
                dispatch(prepareBulkDelete(ids, value, filterData, callback));
                break;
            default:
                dispatch(bulkItems(ids, value, filterData, callback));
                break;
        }
    };
